import React, { Component } from 'react';
import { Router } from 'react-router';
import ReactSwipe from 'react-swipe';
import {isTouchDevice} from '../utils/Browser';

import TeX from 'react-components/tex';
import Lazy from 'lazy.js';
import _ from 'lodash';
import ReactFireMixin from 'reactfire';
import {firebaseRoot, snapshotMap, snapshotToArray} from '../utils/firebase-utils';

import TouchLink from '../components/TouchLink';
import TouchButton from '../components/TouchButton';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import ChoiceBox from '../components/ChoiceBox/ChoiceBox';

import MathMarkup from '../components/MathMarkup/MathMarkup';

import Modal from 'react-bootstrap/lib/Modal';

import MobileHeader from '../components/MobileHeader/MobileHeader';
import ExerciseHeader from '../components/ExerciseHeader/ExerciseHeader';
import ExerciseQuestion from '../components/ExerciseQuestion/ExerciseQuestion';
import ExerciseNumericInput from '../components/ExerciseNumericInput/ExerciseNumericInput';
import ExerciseMultipleAnswers from '../components/ExerciseMultipleAnswers/ExerciseMultipleAnswers';
import Answer from '../components/ExerciseMultipleAnswer/ExerciseMultipleAnswer';
import ExerciseResult from '../components/ExerciseResult/ExerciseResult';
import ExerciseHint from '../components/ExerciseHint/ExerciseHint';

import SupportButton from '../components/SupportMailButton/SupportMailButton';

import {translator} from '../translator';
import {getImageCdn} from '../Constants';
import classNames from 'classnames';



function renderAnswer(step) {
    if (step.operation == 'blank') {
        return step.answer;
    }
    let answersArray = step.answer.split(';');
    return answersArray.reduce(function(result, answerPart) {
        // TODO(tirsen): If both the BLK and the answer are latex expressions things go awry. We need to fix that somehow.
        return result.replace("BLK", answerPart);
    }, step.operation);
};


const ModalImage = React.createClass({
    render() {
        if (!this.props.image) {
            return null;
        }
        return (
            <Modal {...this.props} bsSize="large" aria-labelledby="contained-modal-image">
                <Modal.Body className="text-center">
                    <figure className="exercise-image-wrap">
                        <div className="exercise-image"
                             style={{backgroundImage: 'url(' + getImageCdn(this.props.image) + ')'}}></div>
                        <figcaption className="text-muted small">Image for exercise {this.props.caption}</figcaption>
                    </figure>
                </Modal.Body>
                <Modal.Footer>
                    <TouchButton onClick={this.props.onHide}>Close</TouchButton>
                </Modal.Footer>
            </Modal>
        );
    }
});

const HintStep = React.createClass({

    getInitialState() {
        return {
            showStep: false
        }
    },

    showStep() {
        this.setState({showStep: true});
    },

    render() {
        return (
            <div className="step">
                {
                    this.state.showStep ? <div className="step-visible"><Glyphicon glyph="ok"/>
                        <div className="step-visible-content">
                            <MathMarkup text={this.props.children}/>
                        </div>
                    </div> :
                        <TouchButton bsStyle="link" onClick={this.showStep}>Visa steg</TouchButton>
                }
            </div>
        );
    }
});

const ExerciseSummary = React.createClass({

    getInitialState() {
        return {
            currStep: null,
            currHintPos: 0
        };
    },

    clickStep(step) {
        this.setState({
            currStep: step,
            hintModalShow: true,
            showHintButtons: 'visible'
        });
    },

    render() {
        let hintModalClose = () => this.setState({hintModalShow: false});
        const path = this.props.exercisePath;
        const prevLink = this.props.prevExercise && path + this.props.prevExercise.key();
        const nextLink = this.props.nextExercise && path + this.props.nextExercise.key();
        const exercisesLength = this.props.exercisesLength;


        return (
            <div className="exercise-mobile-fullAnswer">
                <div className="exercise-mobile-fullAnswer-lesson">
                    <div className="albert"></div>
                    {this.props.children}
                </div>
                <ol className="steps">
                    {this.props.steps.map((step, i) => {
                        return (
                            <li key={i} className="stepItem" onClick={this.clickStep.bind(this, step)}>
                                <Glyphicon glyph="question-sign"/>
                                <span className="step">
                                    <MathMarkup text={renderAnswer(step)}/>
                                </span>
                            </li>
                        );
                    })}
                </ol>
                <div className="exercise-mobile-pagination">
                    {prevLink && <TouchLink to={prevLink} stateReplace className="btn btn-primary btn-large">Föregående</TouchLink>}
                    {nextLink && <TouchLink to={nextLink} stateReplace className="btn btn-primary">Nästa</TouchLink>}
                </div>
                <Modal
                    show={this.state.hintModalShow}
                    onHide={hintModalClose}
                    aria-labelledby="modal-hint"
                >
                    {this.state.currStep &&
                    <Modal.Body>
                        <div className="hintModal-hint"><MathMarkup>{this.state.currStep.hint}</MathMarkup></div>
                        <div className="hintModal-step">
                            <Glyphicon glyph="ok"/>
                            <span className="hintModal-step-content"><MathMarkup>{renderAnswer(this.state.currStep)}</MathMarkup></span>
                        </div>
                    </Modal.Body>}
                    <Modal.Footer>
                        <TouchButton onClick={hintModalClose}>Ok</TouchButton>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
});

const SingleStep = React.createClass({
    render() {
        const hintText = renderAnswer(this.props.step);
        return (
            <div key={i} className="hints-hint">
                <div className="hints-hint-content">
                    <HintStep>{hintText}</HintStep>
                    <div className="hint">
                        <MathMarkup text={this.props.step.hint}/>
                    </div>
                </div>
            </div>
        );
    }
});

const MultiChoiceStep = React.createClass({

    getInitialState() {
        return {
            selectedChoice: null,
            selectedChoiceIndex: null,
            answered: false
        }
    },

    onSelect(choice, i) {
        this.setState({
            selectedChoice: choice,
            selectedChoiceIndex: i
        });
    },

    answer() {
        this.setState({
            answered: true
        });
    },

    render() {

        var mockOptions = [
            {
                "text": "Laudantium pariatur quaerat",
                "correct": false,
            },
            {
                "text": "Ad amet aperiam",
                "correct": false,
            },
            {
                "text": "42",
                "correct": true,
            },
            {
                "text": "Expedita harum illo",
                "correct": false,
            }
        ];
        return (
            <div className="hints-hint">
                <div className="hints-hint-content">
                    <div className="hint multiChoice">
                        <MathMarkup text={this.props.step.hint}/>
                    </div>
                    <div className="exercise-multipleAnswer-wrap">
                        <div className="exercise-multipleAnswer">
                            {
                                mockOptions.map((choice, i) => {
                                    const choiceClass = classNames({
                                        selected: this.selectedChoiceIndex && this.selectedChoiceIndex == i
                                    });

                                    return(
                                        <ChoiceBox
                                            key={i}
                                            className={choiceClass}
                                            type="radio"
                                            name="answer"
                                            onSelect={this.onSelect.bind(this, choice, i)}
                                            disabled={this.state.isAnswered}
                                            labelToRight={true}
                                            label={choice.text}
                                        />
                                    );
                                })
                            }
                        </div>
                    </div>
                    <TouchButton onClick={this.answer} type="submit" bsStyle="primary" style={{margin: '10px'}}>Svara</TouchButton>
                </div>
            </div>
        );
    }
});

const Hints = React.createClass({

    getInitialState() {
        return {
            currStep: null,
            currHintPos: 0,
            isAnswered: false
        };
    },

    hintPrev(){
        this.refs.HintSwiper.swipe.prev();
        this.setState({
            currHintPos: this.refs.HintSwiper.swipe.getPos()
        });
    },

    hintNext(){
        this.refs.HintSwiper.swipe.next();
        this.setState({
            currHintPos: this.refs.HintSwiper.swipe.getPos()
        });
    },

    answer() {
       console.log(this.props.steps);
    },

    render(){

        let showHintButtons = 'visible';
        if (isTouchDevice()) showHintButtons = 'hidden';

        let farLeft = true;
        let farRight = false;

        if (this.state.currHintPos !== 0) {
            farLeft = false;
        }

        if (this.state.currHintPos === (this.props.steps.length - 1)) {
            farRight = true;
        }


        let isAnswered = 'False';
        if(this.state.isAnswered) {
            isAnswered = 'True';
        }

        /*
         *   TODO: Bug - The "react swiper" is to blaim for the page transition to break.
         *   Maybe add some type of delay on this component?
         * */
        return (
            <div className="exercise-mobile-help">
                <div className={'exercise-mobile-carousel-wrap'}>
                    <ReactSwipe
                        ref="HintSwiper"
                        continuous={false}
                        className="exercise-mobile-carousel"
                    >
                        {this.props.steps.map((step, i) => {
                            if(step.gui === 'Flerval' || step.gui) {
                                return <MultiChoiceStep key={i} step={step} />;
                            } else {
                                return <SingleStep key={i} step={step} />;
                            }
                        })}
                    </ReactSwipe>
                    <div className={'exercise-mobile-carousel-buttons ' + showHintButtons}>
                        <TouchButton className="prev" disabled={farLeft} onClick={this.hintPrev}
                                     title="Föregående"><Glyphicon
                            glyph="arrow-left"/></TouchButton>
                        <TouchButton className="next" disabled={farRight} onClick={this.hintNext}
                                     title="Nästa"><Glyphicon glyph="arrow-right"/></TouchButton>
                    </div>
                </div>
            </div>
        );
    }
});

const MidSection = React.createClass({

    render() {
        let section = null;
        let showAnswer = this.props.showAnswer || false;
        let isAnswered;

        this.props.isAnswered ? isAnswered = 'js-showCorrect' : isAnswered = '';

        if (showAnswer) {
            section = <ExerciseSummary answer={true} steps={this.props.steps} {...this.props}>{this.props.children}</ExerciseSummary>;
        } else {
            section =   <div className="exercise-singel-container">
                <Hints steps={this.props.steps} isMultichoice={this.props.isMultichoice} {...this.props}/>
                {this.props.children}
            </div>;

        }

        return section;
    }
});

const Exercise = React.createClass({
    mixins: [ReactFireMixin],

    contextTypes: {
        history: React.PropTypes.object.isRequired,
        userRef: React.PropTypes.object
    },

    getInitialState() {
        return {
            exercisesLength: null,
            problemExpanded: false,
            book: null,
            response: null,
            attempts: [],
            imageShow: false,
            showAnswer: false,
            completedExercise: null,
            error: null,
            answer: null,
            isAnswered: false
        };
    },

    componentWillMount() {
        this.bindAsObject(
            firebaseRoot
                .child('content/books')
                .child(this.props.params.bookId),
            'book');

        this.bindAsArray(
            firebaseRoot
                .child('content/subchapters')
                .child(this.props.params.bookId)
                .child(this.props.params.chapterId),
            'subchapters');

        this.bindAsObject(
            firebaseRoot
                .child('content/exercises')
                .child(this.props.params.bookId)
                .child(this.props.params.chapterId),
            'exercises');

        this.bindAsObject(
            firebaseRoot
                .child('userData')
                .child(this.context.userRef.key())
                .child("lastViewedExercise")
                .child(this.props.params.bookId)
                .child(this.props.params.chapterId)
                .child(this.props.params.subchapterId),
            'lastViewed');

        this.bindAsObject(
            firebaseRoot
                .child('content/exercises')
                .child(this.props.params.bookId)
                .child(this.props.params.chapterId)
                .child(this.props.params.subchapterId)
                .child(this.props.params.exerciseId),
            'exercise');

        this.bindAsDataSnapshot(
            firebaseRoot.child('content/exercises')
                .child(this.props.params.bookId)
                .child(this.props.params.chapterId)
                .child(this.props.params.subchapterId)
                .orderByPriority(),
            'exercisesList');
    },

    _handleSubmit(solutionText) {
        let isCorrect = this.evaluateSolution(solutionText) ? 'correct' : 'incorrect';
        this.attemptsRef.push({text: solutionText, evaluation: isCorrect});
    },

    lessonClickHandler() {
        firebaseRoot.child('content/exercises').child(this.props.params.bookId).child(this.props.params.chapterId).child(this.props.params.subchapterId).child(this.props.params.exerciseId).once("value", (snapshot) => {
            var data = snapshot.val();
            this.context.history.push(`/lesson/${data.lesson}`);
        });
    },

    evaluateSolution(solutionText) {
        var e = translator.evaluate(solutionText, this.state.exercise);
        let r;
        e === 0 ? r = true : r = false;
        return r;
    },

    evaluationIcon({evaluation}) {
        if (evaluation == 'correct') {
            return <ActionGrade/>;
        } else {
            return null;
        }
    },

    showAnswer() {
        this.setState({showAnswer: true});

        var fbRef = firebaseRoot.child('userData')
            .child(this.context.userRef.key())
            .child("lastViewedExercise")
            .child(this.props.params.bookId)
            .child(this.props.params.chapterId)
            .child(this.props.params.subchapterId);

        const list = snapshotToArray(this.state.exercisesList);
        const newPos = list.map(e => e.key().toString()).sort().indexOf(this.props.params.exerciseId);
        const oldPos = list.map(e => e.key().toString()).sort().indexOf(this.state.lastViewed['.value']);

        this.setState({
            exercisesLength: _.size(list)
        });

        if(newPos > oldPos) {
            console.log(`${this.state.exercise['.key']} is saved as lastViewedExercise`);
            fbRef.set(this.state.exercise['.key'], (error) => {
                    if (error) console.log(error);
                }
            );
        } else {
            console.log(this.state.exercise['.key'] + " Exercise id is lower than the existing one and therefore not saved.");
        }
    },

    selectedAnswer(val) {
        this.setState({
            answer: val
        })
    },

    submitAnswer() {
        this.setState({
            isAnswered: true
        });
    },

    problemExpander() {
        this.state.problemExpanded ? this.setState({problemExpanded: false}) : this.setState({problemExpanded: true});
    },

    render() {
        if (!this.areAllBindingsLoaded()) {
            return <div>Loading...</div>;
        }

        const {exercise} = this.state;
        let imageClose = () => this.setState({imageShow: false});

        let showImageButton = null;
        if (this.state.exercise.image) {
            showImageButton = (
                <TouchButton
                    bsStyle="default"
                    bsSize="sm"
                    onClick={()=>this.setState({ imageShow: true })}
                >
                    <Glyphicon glyph="picture"/> Visa bild
                </TouchButton>);
        }

        let answerInput = null;

        if (exercise.answerType === 'multiple') {
            answerInput = (<ExerciseMultipleAnswers/>);
        } else if (exercise.answerType === 'numericInput') {
            answerInput = (<ExerciseNumericInput onInputSubmit={this._handleSubmit}/>);
        } else {
            answerInput = (<ExerciseNumericInput onInputSubmit={this._handleSubmit}/>);
        }

        let problemExpander = 'js-prob-min';
        this.state.problemExpanded ? problemExpander = 'js-prob-max' : problemExpander = 'js-prob-min';

        let calculator = null;
        const calculatorTooltip = (<Tooltip id="calculator">Calculator allowed</Tooltip>);
        if (exercise.calculator) {
            calculator = (
                <div className="calculator-wrap">
                    <OverlayTrigger
                        placement="left"
                        overlay={calculatorTooltip}
                    >
                        <div className="calculator"></div>
                    </OverlayTrigger>
                </div>
            );
        }

        const list = snapshotToArray(this.state.exercisesList);
        const i = list.map(e => e.key().toString()).sort().indexOf(this.props.params.exerciseId);

        const prevExercise = list[i - 1];
        const nextExercise = list[i + 1];

        const path = `/book/${this.props.params.bookId}/${this.props.params.chapterId}/${this.props.params.subchapterId}/`;
        const prevLink = prevExercise && path + prevExercise.key();
        const nextLink = nextExercise && path + nextExercise.key();

        return (
            <div className="screen-wrap">
                <MobileHeader
                    lessonId={this.props.params.lessonId}
                    exercise={this.state.exercise}
                    book={this.state.book}
                    type='exercise'
                    // Don't show the back button on the root screen.
                    backButton={this.props.location.pathname.length > 1}
                />
                <div className="screen-content">
                    <div className={'exercise-mobile-wrapper ' + problemExpander}>
                        <div className="exercise-mobile-problem">
                            <div className="exercise-mobile-problem-question">
                                <MathMarkup text={this.state.exercise.text} />
                            </div>
                            {showImageButton}
                            <ModalImage
                                image={this.state.exercise.image}
                                show={this.state.imageShow}
                                caption={exercise['.key']}
                                onHide={imageClose}
                            />
                        </div>

                        <div className="exercise-mobile-problem-expander">
                            <TouchButton onClick={this.problemExpander}><span className="problem-hide">Göm</span><span className="problem-show">Visa</span> övning</TouchButton>
                        </div>

                        {exercise.steps ?<MidSection
                            exercisePath={`/book/${this.props.params.bookId}/${this.props.params.chapterId}/${this.props.params.subchapterId}/`}
                            currExercise={i}
                            prevExercise={prevExercise}
                            nextExercise={nextExercise}
                            exercisesLength={this.state.exercisesLength}
                            exercise={this.state.exercise}
                            steps={this.state.exercise.steps}
                            showAnswer={this.state.showAnswer}
                            isAnswered={this.state.isAnswered}
                            onSelect={this.selectedAnswer}
                        >
                            <div className="exercise-lesson-wrap">
                                <TouchButton
                                    bsStyle="link"
                                    bsSize="large"
                                    className="exercise-lesson"
                                    onClick={this.lessonClickHandler}
                                >
                                    <Glyphicon glyph="play"/> Se lektion
                                </TouchButton>
                            </div>
                        </MidSection>:
                            <div className="exercise-singel-container">
                                <div className="exercise-mobile-help no-info">
                                    <p className="info">Vi har ingen information för den här uppgiften än.</p>
                                </div>
                            </div>
                        }

                        <div className="exercise-mobile-bottom">
                            <SupportButton
                                userEmail={this.context.userRef && this.context.userRef.val() ? this.context.userRef.val().email : ''}
                                book={this.props.params.bookId}
                                chapter={this.props.params.chapterId}
                                subChapter={this.props.params.subchapterId}
                                exercise={this.props.params.exerciseId}
                                lesson=""
                            />
                            {exercise.steps ? (this.state.showAnswer ? null : <TouchButton bsStyle="primary" bsSize="large" block onClick={this.showAnswer}>Jag förstår</TouchButton>)
                            : <div className="exercise-mobile-pagination">
                                {prevLink && <TouchLink to={prevLink} stateReplace className="btn btn-primary btn-large">Föregående</TouchLink>}
                                {nextLink && <TouchLink to={nextLink} stateReplace className="btn btn-primary">Nästa</TouchLink>}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

export default Exercise;



/** WEBPACK FOOTER **
 ** ./src/screens/Exercise.js
 **/